import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('stateTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      geoSource: '@',
      selectedLists: '<',
      selectedOptions: '<'
    },
    template: require("../templates/stateTargeting.html"),
    controllerAs: '$stateTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.targetingOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
    }
});
